export const locales = ["en", "fr", "es", "pt"];

const dictionary = {
  "en": {
    "lang_label": "Language",
    "app_name": "depot",
    "app_subtitle": "Blobstore browser for developers",
    "go_to_file_browser": "Go to file browser",
    "menu": "Menu",
    "open_menu": "Open menu",
    "close_menu": "Close menu",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "pause_polling": "Pause polling",
    "resume_polling": "Resume polling",
    "refresh": "Refresh",
    "nav_storage": "Storage",
    "nav_settings": "Settings",
    "nav_runtime": "Runtime",
    "logout": "Logout",
    "bucket": "Bucket",
    "status": "Status",
    "navigation": "Navigation",
    "pause": "Pause",
    "resume": "Resume",
    "login_subtitle": "Blobstore browser for developers",
    "login_enter_key": "Enter your API key",
    "login_api_key_required": "API key is required",
    "login_invalid_key": "Invalid API key",
    "login_server_error": "Server error: {status}",
    "login_connection_failed": "Connection failed",
    "login_authenticating": "Authenticating...",
    "login_dashboard": "Continue",
    "login_acdev_headline": "ship faster with baseblox",
    "login_acdev_description": "baseblox is a suite of microservices ready to drop into your infrastructure which reduces the time to build complex applications and the costs of platforms like AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licensing & support",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "fr": {
    "lang_label": "Langue",
    "app_name": "depot",
    "app_subtitle": "Navigateur de stockage objet pour développeurs",
    "go_to_file_browser": "Aller au navigateur de fichiers",
    "menu": "Menu",
    "open_menu": "Ouvrir le menu",
    "close_menu": "Fermer le menu",
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "pause_polling": "Mettre en pause",
    "resume_polling": "Reprendre",
    "refresh": "Rafraîchir",
    "nav_storage": "Stockage",
    "nav_settings": "Paramètres",
    "nav_runtime": "Runtime",
    "logout": "Déconnexion",
    "bucket": "Compartiment",
    "status": "Statut",
    "navigation": "Navigation",
    "pause": "Pause",
    "resume": "Reprendre",
    "login_subtitle": "Navigateur de stockage objet pour développeurs",
    "login_enter_key": "Entrez votre clé API",
    "login_api_key_required": "La clé API est obligatoire",
    "login_invalid_key": "Clé API invalide",
    "login_server_error": "Erreur serveur : {status}",
    "login_connection_failed": "Échec de connexion",
    "login_authenticating": "Authentification...",
    "login_dashboard": "Tableau de bord",
    "login_acdev_headline": "allez plus vite avec baseblox",
    "login_acdev_description": "baseblox est une suite de microservices prets a integrer dans votre infrastructure pour reduire le temps de developpement des applications complexes et les couts de plateformes comme AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licences & support",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "es": {
    "lang_label": "Idioma",
    "app_name": "depot",
    "app_subtitle": "Explorador de almacenamiento para desarrolladores",
    "go_to_file_browser": "Ir al explorador de archivos",
    "menu": "Menú",
    "open_menu": "Abrir menú",
    "close_menu": "Cerrar menú",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "pause_polling": "Pausar sondeo",
    "resume_polling": "Reanudar sondeo",
    "refresh": "Actualizar",
    "nav_storage": "Almacenamiento",
    "nav_settings": "Configuración",
    "nav_runtime": "Runtime",
    "logout": "Cerrar sesión",
    "bucket": "Bucket",
    "status": "Estado",
    "navigation": "Navegación",
    "pause": "Pausar",
    "resume": "Reanudar",
    "login_subtitle": "Explorador de almacenamiento para desarrolladores",
    "login_enter_key": "Ingresa tu clave API",
    "login_api_key_required": "La clave API es obligatoria",
    "login_invalid_key": "Clave API inválida",
    "login_server_error": "Error del servidor: {status}",
    "login_connection_failed": "Error de conexión",
    "login_authenticating": "Autenticando...",
    "login_dashboard": "Panel",
    "login_acdev_headline": "lanza mas rapido con baseblox",
    "login_acdev_description": "baseblox es una suite de microservicios lista para integrarse en tu infraestructura y reducir tanto el tiempo necesario para crear aplicaciones complejas como los costes de plataformas como AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licencias y soporte",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "pt": {
    "lang_label": "Idioma",
    "app_name": "depot",
    "app_subtitle": "Navegador de armazenamento para desenvolvedores",
    "go_to_file_browser": "Ir para o navegador de arquivos",
    "menu": "Menu",
    "open_menu": "Abrir menu",
    "close_menu": "Fechar menu",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "pause_polling": "Pausar polling",
    "resume_polling": "Retomar polling",
    "refresh": "Atualizar",
    "nav_storage": "Armazenamento",
    "nav_settings": "Configurações",
    "nav_runtime": "Runtime",
    "logout": "Sair",
    "bucket": "Bucket",
    "status": "Status",
    "navigation": "Navegação",
    "pause": "Pausar",
    "resume": "Retomar",
    "login_subtitle": "Navegador de armazenamento para desenvolvedores",
    "login_enter_key": "Digite sua chave de API",
    "login_api_key_required": "A chave de API é obrigatória",
    "login_invalid_key": "Chave de API inválida",
    "login_server_error": "Erro do servidor: {status}",
    "login_connection_failed": "Falha de conexão",
    "login_authenticating": "Autenticando...",
    "login_dashboard": "Painel",
    "login_acdev_headline": "entregue mais rapido com baseblox",
    "login_acdev_description": "baseblox e uma suite de microsservicos pronta para entrar na sua infraestrutura e reduzir tanto o tempo de criacao de aplicacoes complexas quanto os custos de plataformas como a AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licenciamento e suporte",
    "login_acdev_contact": "support@acdevservices.com"
  }
};

export function t(locale, key, params = {}) {
  let value = dictionary[locale]?.[key] ?? dictionary.en[key] ?? key;
  Object.entries(params).forEach(([k, v]) => {
    value = value.replaceAll(`{${k}}`, String(v));
  });
  return value;
}
